enum Edibility {
    NotEditable = 0,
    Editable = 1,
    NotEditableForFlip = 2,
}

export default Edibility;
